import React from 'react';
import {
  Room,
  Extension,
  Layers,
  QueueMusic,
  CalendarMonth,
  Radio,
} from '@mui/icons-material';

export const SCHEDULING_TABS = [
  { label: 'Zones', path: '/scheduling/zones', icon: <Room /> },
  { label: 'Segments', path: '/scheduling/segments', icon: <Extension /> },
  { label: 'Sequences', path: '/scheduling/sequences', icon: <Layers /> },
  { label: 'Playlists', path: '/scheduling/playlists', icon: <QueueMusic /> },
  { label: 'Schedules', path: '/scheduling/schedules', icon: <CalendarMonth /> },
  { label: 'Channels', path: '/scheduling/channels', icon: <Radio /> },
];

export const SCHEDULING_ACCENT_COLOR = '#14b8a6';
